(function () {
  function initSlider(section) {
    var track = section.querySelector('[data-ingredient-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.ingredient-spotlight__slide');
    if (!slides.length) return;

    var pills = section.querySelectorAll('.ingredient-spotlight__pill');
    var dots = section.querySelectorAll('[data-ingredient-dot]');
    var prev = section.querySelector('[data-ingredient-prev]');
    var next = section.querySelector('[data-ingredient-next]');
    var current = 0;

    function setActive(idx) {
      current = idx;
      var tablist = section.querySelector('.ingredient-spotlight__pills');
      if (tablist) tablist.style.setProperty('--ingredient-tab-index', idx);
      pills.forEach(function (pill) {
        var match = pill.getAttribute('data-ingredient') === String(idx);
        pill.classList.toggle('is-active', match);
        pill.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      dots.forEach(function (dot) {
        var selected = dot.getAttribute('data-ingredient-dot') === String(idx);
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
      });
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-ingredient') === String(idx));
      });
    }

    function goTo(idx) {
      idx = Math.max(0, Math.min(idx, slides.length - 1));
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      setActive(idx);
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        goTo(parseInt(pill.getAttribute('data-ingredient'), 10));
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-ingredient-dot'), 10));
      });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // Keep active state in sync when the user swipes/scrolls the track natively
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var w = track.clientWidth || 1;
        var idx = Math.max(0, Math.min(Math.round(track.scrollLeft / w), slides.length - 1));
        if (idx !== current) setActive(idx);
      }, 90);
    });
  }

  function initModal(section) {
    var trigger = section.querySelector('[data-ingredients-trigger]');
    if (!trigger) return;
    var modalId = trigger.getAttribute('aria-controls');
    if (!modalId) return;
    // Modal lives outside the .ingredient-spotlight wrapper (so look at document)
    var modal = document.getElementById(modalId);
    if (!modal) return;
    var closers = modal.querySelectorAll('[data-ingredients-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.ingredient-spotlight__modal-close');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', handleKey);
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKey);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function handleKey(e) {
      if (e.key === 'Escape') close();
    }

    trigger.addEventListener('click', open);
    closers.forEach(function (c) {
      c.addEventListener('click', close);
    });
  }

  function initDescriptionClamp(section) {
    var cards = section.querySelectorAll('.ingredient-spotlight__slide-card');

    cards.forEach(function (card) {
      var desc = card.querySelector('[data-ingredient-desc]');
      var toggle = card.querySelector('[data-ingredient-desc-toggle]');
      if (!desc || !toggle) return;

      function refresh() {
        // Measure while collapsed: only offer "Read more" if the copy is clipped
        card.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.hidden = desc.scrollHeight - desc.clientHeight <= 2;
      }

      toggle.addEventListener('click', function () {
        var expanded = card.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });

      refresh();
      window.addEventListener('resize', refresh);
      // CSS lazy-loads (css-delay) and fonts settle after DOMContentLoaded — re-measure then
      window.addEventListener('load', refresh);
    });
  }

  function initSpotlight(section) {
    initSlider(section);
    var stats = section.querySelector('.formthr-ingredient-stats');
    if (stats && !stats.dataset.countReady && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stats.dataset.countReady = 'true';
      var observer = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        var start = performance.now();
        var numbers = stats.querySelectorAll('[data-count-to]');
        function frame(now) {
          if (!stats.isConnected) return;
          var progress = Math.min((now - start) / 850, 1);
          numbers.forEach(function(number) { number.textContent = Math.round(Number(number.dataset.countTo) * (1 - Math.pow(1-progress, 3))); });
          if (progress < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }, {threshold: .5});
      observer.observe(stats);
    }
    initModal(section);
    initDescriptionClamp(section);
  }

  function initAll() {
    document.querySelectorAll('.ingredient-spotlight').forEach(initSpotlight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ingredient-spotlight');
    if (section) initSpotlight(section);
  });
})();
